import { AssetsTranslations } from "../CountryPage";

import firstSectionMobile from "../../../assets/images/DEU/first-section-mobile_DEU.jpg";
import firstSectionDesktop from "../../../assets/images/DEU/first-section-desktop_DEU.jpg";
import secondSectionMobile from "../../../assets/images/DEU/second-section-mobile_DEU.jpg";
import secondSectionDesktop from "../../../assets/images/DEU/second-section-desktop_DEU.jpg";
import thirdSectionMobile from "../../../assets/images/DEU/third-section-mobile_DEU.jpg";
import thirdSectionDesktop from "../../../assets/images/DEU/third-section-desktop_DEU.jpg";
import fourthSectionMobile from "../../../assets/images/DEU/fourth-section-mobile_DEU.jpg";
import fourthSectionDesktop from "../../../assets/images/DEU/fourth-section-desktop_DEU.jpg";

export const germanTranslatedAssets: AssetsTranslations = {
  firstSectionMobile,
  firstSectionDesktop,
  secondSectionMobile,
  secondSectionDesktop,
  thirdSectionMobile,
  thirdSectionDesktop,
  fourthSectionMobile,
  fourthSectionDesktop,
};

export const germanTranslations = {
  "landingPage.selection.title": "Willkommen bei Cora BC",
  "landingPage.selection.body":
    "Um Informationen über die App zu erhalten, wähle unten das Land aus, in dem Du wohnst:",
  "landingPage.hero.title": "Deine Begleiterin in Deinem Leben mit Brustkrebs",
  "landingPage.hero.body":
    "Erhalte Unterstützung und wichtige Informationen rund um das Thema Brustkrebs, um ein selbstbestimmteres und aufgeklärtes Leben zu führen.",
  "landingPage.hero.preLaunch.cta": "Registriere dich",
  "landingPage.hero.sponsored": "",
  "landingPage.usp.ho.label": "Deine Gesundheit im Blick",
  "landingPage.usp.ho.title":
    "Erhalte Unterstützung für den Umgang mit Veränderungen in deiner Gesundheit",
  "landingPage.usp.ho.body":
    "Dokumentiere Deine Erfahrungen regelmäßig, um Veränderungen in Deiner Gesundheit festzuhalten. Einfache und informative Grafiken helfen Dir dabei, besser informiert zu sein und mehr Kontrolle über Deine Gesundheit und irgendwelche Veränderungen zu haben.",
  "landingPage.usp.ia.label": "Unterstützung bei der Therapietreue",
  "landingPage.usp.ia.title":
    "Erhalte Unterstützung bei der Einnahme deiner Medikamente",
  "landingPage.usp.ia.body":
    "Nutze Erinnerungen und Anleitungen um Deine neue Routine zu etablieren, indem Du alle Medikamente an einem Ort verwalten kannst.",
  "landingPage.usp.si.label": "Informationen und Unterstützung für Dich",
  "landingPage.usp.si.title": "Erhalte Inhalte genau zugeschnitten auf Dich",
  "landingPage.usp.si.body":
    "Bekomme Inhalte angeboten, die Dir dabei helfen, mit Deiner Behandlung und sonstigen Erfahrungen besser umzugehen und Du kannst jederzeit und überall darauf zugreifen. Lerne in Deinem eigenen Tempo und widme Dich den Themen, welche für Dich relevant sind rund um Brustkrebs und Deinen Alltag.",
  "landingPage.usp.cs.label": "Hilfe für Deine Arztgespräche",
  "landingPage.usp.cs.title":
    "Erhalte Unterstützung um selbstbestimmter in Deiner Behandlung zu sein",
  "landingPage.usp.cs.body":
    "Verwalte alle Deine anstehenden Termine in Cora. Erhalte gezielte Unterstützung in der Vorbereitung auf Deine Termine und die Möglichkeit Notizen zu machen, um eine aktivere Rolle in den Gesprächen und Deiner gesamten Behandlung zu erlangen.",
  "landingPage.moreFeatures.title":
    "...weitere Funktionen und Vorteile von Cora BC",
  "landingPage.moreFeatures.feel.title":
    "Fühle Dich durch gute Vorbereitung bestärkt",
  "landingPage.moreFeatures.feel.body":
    "Notiere Dir relevante Informationen und Fragen, die Du rund um das Thema Brustkrebs hast, damit Du sie mit Deinem erweiterten Behandlungsteam besprechen kannst.",
  "landingPage.moreFeatures.discover.title":
    "Genieße ein einfaches aber ansprechendes Design",
  "landingPage.moreFeatures.discover.body":
    "Neueste Design Vorstellungen für eine einfache und unkomplizierte Nutzung",
  "landingPage.moreFeatures.tools.title":
    "Volle Flexibilität für Deinen Alltag",
  "landingPage.moreFeatures.tools.body":
    "Passe Deine Benachrichtigungen an einen Zeitplan an, der am besten zu Dir passt.",
  "landingPage.signUp.label": "Kommende App-Veröffentlichung",
  "landingPage.signUp.title": "Melde Dich an, um informiert zu werden",
  "landingPage.signUp.body":
    "Cora BC wird im Dezember 2024 veröffentlicht. Melde Dich mit Deiner E-Mail-Adresse an, um benachrichtigt zu werden, sobald die App zum Download bereitsteht.",
  "landingPage.signUp.input.placeholder": "E-Mail-Adresse hier eingeben",
  "landingPage.signUp.button": "Registrieren",
  "landingPage.signUp.disclaimer":
    "Mit deiner Registrierung erklärst Du Dich damit einverstanden, Informationen über das Produkt Cora BC zu erhalten.",
  "landingPage.signUp.complete.title":
    "Vielen Dank für Deine Registrierung. Du erhältst eine E-Mail, sobald Cora BC zum Download bereitsteht.",
  "landingPage.signUp.complete.body":
    "Vielen Dank für Deine Registrierung. Du erhältst eine E-Mail, sobald Cora BC zum Download bereitsteht.",
  "landingPage.footer.privacyPolicy": "Datenschutzrichtlinie",
  "landingPage.footer.licenses": "Lizenzen",
  "landingPage.download.title": "Cora BC herunterladen",
  "landingPage.download.body":
    "Deine Begleiterin in Deinem Leben mit Brustkrebs. Jetzt kostenlos herunterladen.",
  "landingPage.topBar.label": "Erscheint im Dezember 2024",
  "landingPage.topBar.body":
    "Melde Dich an, um über die Veröffentlichung benachrichtigt zu werden",
  "landingPage.topBar.button": "Registrieren",
};
